/**
 * Vollanalyse S6: EIN try/catch-sicherer localStorage-Zugriff für lokale
 * UI-Präferenzen. Vorher lebten drei Idiome nebeneinander: AppLayout mit
 * eigenem readLocal/writeLocal, CustomersPage mit eigenem JSON-try/catch und
 * die Plantafel-Filter ganz UNGESCHÜTZT — genau im Umfeld (Safari privat,
 * gesperrtes Storage), gegen das sich AppLayout absichert. localStorage kann
 * fehlen oder gesperrt sein; dann gilt der jeweilige Default und die
 * Präferenz ist schlicht nicht persistent.
 */

export function readLocal(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeLocal(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* Präferenz ist optional. */
  }
}

export function removeLocal(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* Präferenz ist optional. */
  }
}

/** JSON-Wert lesen; fehlend, gesperrt oder kaputt → null (Default greift). */
export function readJsonLocal(key: string): unknown {
  const raw = readLocal(key);
  if (raw === null) return null;
  try {
    return JSON.parse(raw) as unknown;
  } catch {
    return null;
  }
}

/** JSON-Wert schreiben; Fehler (Quota, gesperrt) werden verschluckt. */
export function writeJsonLocal(key: string, value: unknown): void {
  writeLocal(key, JSON.stringify(value));
}
